import { request } from '@/service/http'

/**
 *  域名单个查询
 */
export function checkOne(domain: string) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/domain-service/domain/checkOne?domain=${domain}`)
  return methodInstance
}

/**
 *  近似域名
 */
export function similarSuDomainCheck(domain: string) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/domain-service/domain/similarSuDomainCheck?domain=${domain}`)
  return methodInstance
}

/**
 *  其他域名
 */
export function checkOneOnlyEpp(domain: string) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/domain-service/domain/checkOneOnlyEpp?domain=${domain}`)
  return methodInstance
}

/**
 *  多个查询分组
 */
export function getDomainGroups(data: any) {
  const methodInstance = request.Post<any>('/domain-service/domain/getDomainGroups', data)
  return methodInstance
}

/**
 *  批量查询
 */
export function batchCheck(data: any) {
  const methodInstance = request.Post<any>('/domain-service/domain/batchCheck', data)
  return methodInstance
}

/**
 *  查询所有后缀
 */
export function getAllDomainext() {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/domain/getAllDomainext')
  return methodInstance
}

/**
 *  搜索记录添加
 */
export function searchrecordAdd(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/domain-service/searchrecord/add', data)
  return methodInstance
}

/**
 *  添加购物车
 */
export function addToCart(data: any) {
  const methodInstance = request.Post<any>('/domain-service/domain/cart/addToCart', { domainList: data })
  return methodInstance
}

/**
 *  限制词验证
 */
export function sensitiveWord(key: any) {
  const methodInstance = request.Get<Service.ResponseResult<any>>(`/backstage-management/tool/sensitiveWord?text=${key}`)
  return methodInstance
}
